import React from 'react';
import { useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import Header from './Header';
// import Footer from './Footer';
import ToastContainer from './ToastContainer';
import LoadingSpinner from "./LoadingSpinner";
import NotificationsModal from './Modals/NotificationsModal';
import { useNotifications } from '../context/NotificationsContext';

const MainLayout = ({ children }) => {
  // Получаем данные пользователя через API

  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const hideNav = location.pathname === '/login' || location.pathname === '/forgot-password';
  const { isOpen, userId, closeNotifications } = useNotifications();

  return (
      <>
        {!hideNav && <Header/>}
        <div className="main-layout">
          {isAuthenticated !== null ? children : <LoadingSpinner text="Загрузка страницы..."/>}
        </div>

        {/*<Footer />*/}
        <ToastContainer/>
        <NotificationsModal
          isOpen={isOpen}
          onClose={closeNotifications}
          userId={userId}
        />
      </>
  );
};

export default MainLayout;